import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateCargoTypeActions as Actions,
  CreateCargoTypeRequestAction as RequestAction,
} from 'store/ducks/cargoTypes';

export function* createCargoTypeRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `cargo-types`, postData);
    onSuccess && onSuccess();
    notify('success', 'Tipo de carga criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
